import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  data: {
    models: [],
    manual: {
      stats: [],
    },
    not_confident_output_stats: [],
    not_confident_output_combinations: [],
    confident_output_stats: [],
    confident_output_combinations: [],
  },
};

const invalidateManualStats = (state) => {
  //console.log("Invalidating Manual Stats");
  state.data.manual.stats.forEach((statRow, statIdx) => {
    state.data.manual.stats[statIdx].value = "-";
  });
  return state;
};

const invalidateNotConfidentStats = (state) => {
  //console.log("Invalidating Not Confident Stats");
  state.data.not_confident_output_stats.forEach((statRow, statIdx) => {
    state.data.not_confident_output_stats[statIdx].value = "-";
  });
  state.data.not_confident_output_combinations.forEach((dataRow, dataIdx) => {
    state.data.not_confident_output_combinations[dataIdx]["Total %"] = "-";
  });
  return state;
};

const invalidateAutoStats = (state) => {
  //console.log("Invalidating AUTO Stats");
  state.data.confident_output_combinations.forEach((statRow, statIdx) => {
    state.data.confident_output_combinations[statIdx].value = "-";
  });
  state.data.confident_output_stats.forEach((dataRow, dataIdx) => {
    state.data.confident_output_stats[dataIdx]["Total %"] = "-";
    state.data.confident_output_stats[dataIdx]["Est. Acc"] = "-";
  });
  return state;
};

const invalidateAllStats = (state) => {
  //console.log("Invalidating All Stats");
  state = invalidateManualStats(state);
  state = invalidateNotConfidentStats(state);
  state = invalidateAutoStats(state);
  return state;
};

const autoflowSlice = createSlice({
  name: "autoflow",
  initialState,
  reducers: {
    updateAutomationConfig(state, action) {
      //console.log("Update Automation Reducer Called");

      state.config = action.payload;
      state = invalidateAllStats(state);
    },
    updateAutomationData(state, action) {
      //console.log("Updating Automation Data");
      state = invalidateAllStats(state);
      state.data = action.payload;
    },
    updateManualSampleRate(state, action) {
      state.config.manual.sample_rate = action.payload;
      state = invalidateManualStats(state);
      state = invalidateAutoStats(state);
    },
    updateModelLabelEnabled(state, action) {
      const { model_name, label, enabled } = action.payload;
      state.config.models[model_name].categories[label].enabled = enabled;
      state = invalidateAllStats(state);
    },
    updateModelConfidence(state, action) {
      /**
       * Update the confidence parameter, and invalidate the estimated accuracy for the label, and other stats
       */
      const { model_name, label, confidence } = action.payload;
      state.config.models[model_name].categories[label].confidence = confidence;
      state = invalidateAllStats(state);
      state.data.models.forEach((model, modelIdx) => {
        if (model.name === model_name) {
          model.modelLabelData.forEach((labelRow, labelIdx) => {
            if (labelRow.Output === label) {
              state.data.models[modelIdx].modelLabelData[labelIdx][
                "Est. Accuracy"
              ] = "-";
            }
          });
        }
      });
    },
  },
});

// eslint-disable-next-line no-empty-pattern
export const {} = autoflowSlice.actions;

export default autoflowSlice.reducer;
